import type { TableColumnsType } from 'antd'
import { Avatar, message, Table } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { useEffect, useMemo } from 'react'
import { HiMiniNoSymbol } from 'react-icons/hi2'
import { useNavigate } from 'react-router-dom'
import {
  GetFoldersListDto,
  FolderOrderBy,
  PlaylistFolder,
} from '../../utils/redux/moodsSlice'
import {
  listenerMiddleware,
  store,
  useAppDispatch,
  useAppSelector,
} from '../../utils/redux/store'
import { AsyncThunk } from '@reduxjs/toolkit'
import { UploadedFolderDestination } from './NewFolder'
import { TableActions } from '../PlaylistsTable'

interface Props {
  uploadedDestination: UploadedFolderDestination
  attemptGetList: AsyncThunk<PlaylistFolder[], GetFoldersListDto, AsyncThunkConfig>
  attemptDelete: AsyncThunk<string, string, AsyncThunkConfig>
  folder: Record<string, PlaylistFolder>
  editPath: string
}
export default function AllFolders({
  folder,
  uploadedDestination,
  attemptGetList,
  attemptDelete,
  editPath,
}: Props) {
  const basicColumns: TableColumnsType<PlaylistFolder> = [
    {
      title: 'Poster',
      dataIndex: 'image',
      render: (value) => (
        <Avatar
          shape="square"
          src={`${process.env.REACT_APP_UPLOADED_BASE_URL}/${uploadedDestination}/${value}`}
          icon={<HiMiniNoSymbol />}
        />
      ),
      width: 80,
    },
    {
      title: 'Title',
      dataIndex: 'title',
    },
  ]

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      attemptGetList({
        skip: 0,
        limit: 200,
        oderBy: FolderOrderBy.TITLE,
      }),
    )
  }, [])

  useAttemptListener({
    attempt: attemptDelete,
    listenerMiddleware: listenerMiddleware,

    onFulfilled: () => {
      message.success('Folder has been removed successfully!')
    },
  })
  const columns: TableColumnsType<PlaylistFolder> = useMemo(() => {
    return [
      ...basicColumns,
      {
        title: 'Action',
        key: 'action',
        width: 120,
        render: (_, folder) => (
          <TableActions
            confirm={{
              title: `Are you sure you want to delete ${folder.title} playlist?`,
            }}
            onDelete={() => {
              dispatch(attemptDelete(folder._id))
            }}
            onEdit={() => {
              navigate(`${editPath}/${folder._id}`)
            }}
          />
        ),
      },
    ]
  }, [])

  const navigate = useNavigate()

  return (
    <>
      <Table<PlaylistFolder>
        size={'small'}
        sticky
        columns={columns}
        rowKey={(mood) => mood._id}
        dataSource={Object.values(folder)}
        // scroll={{ y: '70vh' }}
      />
    </>
  )
}
